import cloudbase from '@cloudbase/js-sdk'

const app = cloudbase.init({
  env: import.meta.env.VITE_TCB_ENV || 'cloudbase-3gianxb15fbd1fc1',
  region: import.meta.env.VITE_TCB_REGION || 'ap-shanghai'
})

const auth = app.auth({ persistence: 'local' })

export async function ensureLogin() {
  const state = await auth.getLoginState()
  if (state) return
  await auth.signInAnonymously()
}

/**
 * Call the 'api' cloud function with a given action and params.
 * All database operations go through this single entry point.
 */
export async function callApi(action: string, params: Record<string, any> = {}): Promise<any> {
  await ensureLogin()
  const result = await app.callFunction({
    name: 'api',
    data: { action, ...params }
  })
  return (result as any).result
}

export { app, auth }
